import FinalStep from './container';

export default FinalStep;



// WEBPACK FOOTER //
// ./src/components/Steps/FinalStep/index.js